import type { User } from '@/types/user';

export const FETCH_USER_DATA_STARTED = 'FETCH_USER_DATA_STARTED' as const;
export const FETCH_USER_DATA_FULFILLED = 'FETCH_USER_DATA_FULFILLED' as const;
export const SET_LOCALE = 'SET_LOCALE' as const;

export const fetchUserData = (params: unknown) => ({
  type: FETCH_USER_DATA_STARTED,
  payload: params,
});

export const fetchUserDataFulfilled = (payload: User) => ({
  type: FETCH_USER_DATA_FULFILLED,
  payload,
});

export const setLocale = (locale: string) => ({
  type: SET_LOCALE,
  payload: locale,
});
